import cardimg1 from "../assets/gas.png";
import cardimg3 from "../assets/fire.png";
import logo1 from "../assets/logo1.png";
import logo2 from "../assets/logo2.png";
import logo3 from "../assets/logo3.png";
import logo4 from "../assets/logo4.png";
import logo5 from "../assets/logo5.png";
import logo6 from "../assets/logo6.png";
import logo7 from "../assets/logo7.png";
import logo8 from "../assets/logo8.png";
import logo9 from "../assets/logo9.png";
import logo10 from "../assets/logo10.png";
import logo11 from "../assets/logo11.png";
import logo12 from "../assets/logo12.png";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import HomeRepairServiceOutlinedIcon from "@mui/icons-material/HomeRepairServiceOutlined";
import gzr from "./gzr.png";
import { API_BASE_URL } from "../components/Config";
import Cookies from "js-cookie";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { color } from "@mui/system";

// 3206879203

export const selectervalues = [
  {
    values: "Select your boiler make",
  },
  {
    values: "Don’t know",
  },
  {
    values: "Unlisted make",
  },
  {
    values: "A O Smith",
  },
  {
    values: "ACV",
  },
  {
    values: "Alde",
  },
  {
    values: "Alpha",
  },
  {
    values: "Aquaflame",
  },
  {
    values: "ARCA",
  },

  {
    values: "Ariston",
  },
  {
    values: "ATAG",
  },

  {
    values: "Atlantic Boilers",
  },
  {
    values: "Atmos",
  },
  {
    values: "Baxi",
  },

  {
    values: " Baxi Heating",
  },
  {
    values: "Baxi Potterton",
  },
  {
    values: "Beeston",
  },
  {
    values: "Biasi",
  },
  {
    values: "BoilerPlan",
  },
  {
    values: "Boulter",
  },
  {
    values: "Boxer",
  },
  {
    values: "British / Scottish Gas",
  },
  {
    values: "Broag Remeha",
  },
  {
    values: "Budurus",
  },
  {
    values: "Burco Maxol",
  },
  {
    values: "Caradon Ideal",
  },
  {
    values: "Chaffoteaux",
  },
  {
    values: "Chaffoteaux et Maury",
  },
  {
    values: "Claudio GR (Vokera)Clyde",
  },
  {
    values: "Coopra BV",
  },
  {
    values: "Cosmogas",
  },
  {
    values: "Daikin",
  },
  {
    values: "DD Heating",
  },
  {
    values: "De Dietrich",
  },
  {
    values: "De Dietrich Thermique",
  },
  {
    values: "Dimplex",
  },
  {
    values: "E.C.A",
  },
  {
    values: "Eco Hometec (UK)",
  },
  {
    values: "Econoflame",
  },
  {
    values: "EHC",
  },
  {
    values: "Elco",
  },
  {
    values: "ELCO Klockner Heiztecnik",
  },
  {
    values: "Eurocal",
  },
  {
    values: "Europa",
  },
  {
    values: "EUROTERM",
  },
  {
    values: "Evo",
  },
  {
    values: "Express",
  },
  {
    values: "Fagor Electrodomesticos S.Coop",
  },
  {
    values: "Fer",
  },
  {
    values: "Fer Industrie",
  },
  {
    values: "Ferroli",
  },
  {
    values: "Fondital",
  },
  {
    values: "Fontecal",
  },
  {
    values: "Geminox",
  },
  {
    values: "Gerkros",
  },

  {
    values: "Gledhill",
  },
  {
    values: "Glotec",
  },
  {
    values: "Glow-worm",
  },
  {
    values: "Halstead",
  },
  {
    values: "Heat Line",
  },
  {
    values: "Heatline",
  },
  {
    values: "Hepworth Heating",
  },
  {
    values: "Hermann Srl",
  },
  {
    values: "Hoval",
  },
  {
    values: "Hydroline",
  },
  {
    values: "ICL Caldaie",
  },
  {
    values: "icon Heating",
  },
  {
    values: "Ideal",
  },
  {
    values: "Ikon",
  },
  {
    values: "i-mini",
  },
  {
    values: "Intergas",
  },
  {
    values: "iQE",
  },
  {
    values: "IRSAP",
  },
  {
    values: "Itho Images bv",
  },
  {
    values: "Johnson & Starley",
  },
  {
    values: "Keston",
  },
  {
    values: "Kidd VHE",
  },

  {
    values: "Lamborghini",
  },
  {
    values: "Lamborghini Caloreclima",
  },
  {
    values: "Lukey",
  },
  {
    values: "Main",
  },
  {
    values: "Malvern",
  },
  {
    values: "Maxol",
  },
  {
    values: "MHS Boilers",
  },

  {
    values: "Mikrofill",
  },
  {
    values: "Morco",
  },
  {
    values: "Motan",
  },
  {
    values: "Myson Combustion Products",
  },
  {
    values: "Navien",
  },
  {
    values: "Nefit Buderus Ltd",
  },
  {
    values: "Nova Florida",
  },
  {
    values: "NST",
  },
  {
    values: "Oceanspa",
  },
  {
    values: "Optia",
  },
  {
    values: "Parkray",
  },
  {
    values: "Potterton",
  },
  {
    values: "Potterton International Heating",
  },
  {
    values: "Potterton Myson",
  },
  {
    values: " Motterton Myson Heating",
  },
  {
    values: "Powermatic",
  },
  {
    values: "Powermax",
  },
  {
    values: "Peo",
  },
  {
    values: "Protherm",
  },
  {
    values: "Quantum",
  },
  {
    values: "Radiant",
  },
  {
    values: "Ravenheat",
  },
  {
    values: "Rayburn",
  },
  {
    values: "Redfyre",
  },
  {
    values: "Remeha",
  },
  {
    values: "Rinnai UK",
  },
  {
    values: "ROC",
  },
  {
    values: "Rotex",
  },
  {
    values: "Sabre",
  },
  {
    values: "SARIgas",
  },
  {
    values: "Saunier Duval",
  },
  {
    values: "Scottish Gas",
  },
  {
    values: "Servowarm",
  },
  {
    values: "Sile SpA",
  },
  {
    values: "Sime",
  },
  {
    values: " Sime Heating Products (UK)",
  },
  {
    values: "Solarcombi",
  },
  {
    values: "Stanley",
  },
  {
    values: "Strebel",
  },
  {
    values: "Termet",
  },
  {
    values: "The White Boiler Company",
  },
  {
    values: "Thorn EMI Heating",
  },
  {
    values: "Trianco",
  },
  {
    values: "Trisave",
  },
  {
    values: "Turco",
  },
  {
    values: "Unical",
  },
  {
    values: "Vaillant",
  },
  {
    values: "Viadrus",
  },
  {
    values: "Viessmann",
  },
  {
    values: "Vokera",
  },
  {
    values: "Vokera BY RIELLO",
  },
  {
    values: "Warmflow",
  },
  {
    values: "Warmhaus",
  },
  {
    values: "Warmworld",
  },
  {
    values: "Wickes",
  },
  {
    values: "Wolf",
  },
  {
    values: "Worcester",
  },
  {
    values: "Yorkpark",
  },
];
export const boilerMakes = [
  { value: "Don’t know" },
  { value: "Unlisted make" },
  { value: "A O Smith" },
  { value: "ACV" },
  { value: "Alde" },
  { value: "Alpha" },
  { value: "Aquaflame" },
  { value: "ARCA" },
  { value: "Ariston" },
  { value: "ATAG" },
  { value: "Atlantic Boilers" },
  { value: "Atmos" },
  { value: "Baxi" },
  { value: "Baxi Heating" },
  { value: "Baxi Potterton" },
  { value: "Beeston" },
  { value: "Biasi" },
  { value: "BoilerPlan" },
  { value: "Boulter" },
  { value: "Boxer" },
  { value: "British / Scottish Gas" },
  { value: "Broag Remeha" },
  { value: "Budurus" },
  { value: "Burco Maxol" },
  { value: "Caradon Ideal" },
  { value: "Chaffoteaux" },
  { value: "Chaffoteaux et Maury" },
  { value: "Claudio GR (Vokera)" },
  { value: "Clyde" },
  { value: "Coopra BV" },
  { value: "Cosmogas" },
  { value: "Daikin" },
  { value: "DD Heating" },
  { value: "De Dietrich" },
  { value: "De Dietrich Thermique" },
  { value: "Dimplex" },
  { value: "E.C.A" },
  { value: "Eco Hometec (UK)" },
  { value: "Econoflame" },
  { value: "EHC" },
  { value: "Elco" },
  { value: "ELCO Klockner Heiztecnik" },
  { value: "Eurocal" },
  { value: "Europa" },
  { value: "EUROTERM" },
  { value: "Evo" },
  { value: "Express" },
  { value: "Fagor Electrodomesticos S.Coop" },
  { value: "Fer" },
  { value: "Fer Industrie" },
  { value: "Ferroli" },
  { value: "Fondital" },
  { value: "Fontecal" },
  { value: "Geminox" },
  { value: "Gerkros" },
  { value: "Gledhill" },
  { value: "Glotec" },
  { value: "Glow-worm" },
  { value: "Halstead" },
  { value: "Heat Line" },
  { value: "Heatline" },
  { value: "Hepworth Heating" },
  { value: "Hermann Srl" },
  { value: "Hoval" },
  { value: "Hydroline" },
  { value: "ICL Caldaie" },
  { value: "icon Heating" },
  { value: "Ideal" },
  { value: "Ikon" },
  { value: "i-mini" },
  { value: "Intergas" },
  { value: "iQE" },
  { value: "IRSAP" },
  { value: "Itho Images bv" },
  { value: "Johnson & Starley" },
  { value: "Keston" },
  { value: "Kidd VHE" },
  { value: "Lamborghini" },
  { value: "Lamborghini Caloreclima" },
  { value: "Lukey" },
  { value: "Main" },
  { value: "Malvern" },
  { value: "Maxol" },
  { value: "MHS Boilers" },
  { value: "Mikrofill" },
  { value: "Morco" },
  { value: "Motan" },
  { value: "Myson Combustion Products" },
  { value: "Navien" },
  { value: "Nefit Buderus Ltd" },
  { value: "Nova Florida" },
  { value: "NST" },
  { value: "Oceanspa" },
  { value: "Optia" },
  { value: "Parkray" },
  { value: "Potterton" },
  { value: "Potterton International Heating" },
  { value: "Potterton Myson" },
  { value: "Motterton Myson Heating" },
  { value: "Powermatic" },
  { value: "Powermax" },
  { value: "Peo" },
  { value: "Protherm" },
  { value: "Quantum" },
  { value: "Radiant" },
  { value: "Ravenheat" },
  { value: "Rayburn" },
  { value: "Redfyre" },
  { value: "Remeha" },
  { value: "Rinnai UK" },
  { value: "ROC" },
  { value: "Rotex" },
  { value: "Sabre" },
  { value: "SARIgas" },
  { value: "Saunier Duval" },
  { value: "Scottish Gas" },
  { value: "Servowarm" },
  { value: "Sile SpA" },
  { value: "Sime" },
  { value: "Sime Heating Products (UK)" },
  { value: "Solarcombi" },
  { value: "Stanley" },
  { value: "Strebel" },
  { value: "Termet" },
  { value: "The White Boiler Company" },
  { value: "Thorn EMI Heating" },
  { value: "Trianco" },
  { value: "Trisave" },
  { value: "Turco" },
  { value: "Unical" },
  { value: "Vaillant" },
  { value: "Viadrus" },
  { value: "Viessmann" },
  { value: "Vokera" },
  { value: "Vokera BY RIELLO" },
  { value: "Warmflow" },
  { value: "Warmhaus" },
  { value: "Warmworld" },
  { value: "Wickes" },
  { value: "Wolf" },
  { value: "Worcester" },
  { value: "Yorkpark" },
];

export const HomeData = [
  {
    title: "When does my WeCare cover start?",
    desc: (
      <>
        <p className="p_bot">
          Your WeCare cover begins immediately upon setting up the plan if
          you're transitioning from another provider.
        </p>
        For those not switching from another provider, there is a 14-day
        exclusion period during which your boiler will not be covered.
      </>
    ),
  },
  {
    title: "Do you cover my boiler?",
    desc: (
      <>
        <p className="p_bot">
          WeCare handles the servicing and repair of all domestic boilers fueled
          by natural gas, excluding Potterton Powermax, Britony, Chaffoteaux,
          Sime, Servowarm, and Elm Le Blanc models.{" "}
        </p>
        Please note that we do not provide services for thermal store boilers,
        solid fuel boilers, oil boilers, electric boilers, back boilers, or
        dual-purpose boilers.
      </>
    ),
  },
  {
    title: "Is there an age limit on the boilers covered by your WeCare?",
    desc: "Certainly not! WeCare are more than happy to cover your boiler, regardless of its age, as long as it operates on natural gas, is in good working condition, and is not on our list of excluded boilers.",
  },
  {
    title: "Will WeCare fix an existing fault?",
    desc: (
      <>
        We might have an alternative plan available, encompassing both initial
        repairs and continuous fault coverage. Feel free to contact a friendly
        member of our customer service team at{" "}
        <strong>+44 (0)3301114442</strong> and they will be more than happy to
        offer you additional details.
      </>
    ),
  },
  {
    title: "How do I book a repair?",
    desc: "As a new WeCare customer, you have the option to either book a one-off repair or if you are an existing customer you can use the WeCare, either selecting 'Book a repair' or contact our 24/7 repairs line at +44 (0)3301114442, where a member of the repairs team will gladly assist you.",
  },
  {
    title: "How long does my WeCare boiler cover plan last?",
    desc: "Each of our plans involves a 12-month agreement. Following this period, you have the flexibility to decide whether you wish to renew or not.",
  },
  {
    title: "When will you send an engineer if I need a repair?",
    desc: (
      <>
        <ul>
          <li>
            In case of emergency repairs, we typically respond within two hours.{" "}
          </li>
          <li>
            Urgent repairs receive our attention within one working day.
            <li>
              For general repairs, we make every effort to accommodate your
              schedule and find a suitable day and time slot.
            </li>
          </li>
        </ul>
      </>
    ),
  },
  {
    title: "Do I need to pay a service fee for a repair?",
    desc: "It varies based on whether you opted for coverage with or without a fixed fee per repair. If you choose coverage with a fixed fee, your monthly payments will be lower, but you will incur a set fee for each repair you request.",
  },
  {
    title:
      "What is included in my yearly boiler service, and how can I book it?",
    desc: (
      <>
        Every WeCare boiler and heating cover plan we offer includes an annual
        inspection to ensure the safety and proper functioning of your boiler.
        <p className="p_bot p_top">The inspection in:</p>
        <ul>
          <li>A visual check of the boiler</li>
          <li>Flue gas analysis & efficiency test</li>
          <li>Removal of the boiler cover and inspection if necessary</li>
          <li>System pressure check and adjustment if necessary</li>
          <li>Condensate trap cleaning if necessary</li>
          <li>Verification of the boiler's safe start-up and shutdown</li>
          <li>
            Confirmation that ventilation and flue comply with current Gas
            Safety regulations
          </li>
        </ul>
        <p className="p_top">
          When it's time for your service, we automatically assign an engineer
          who will contact you to coordinate a convenient time. After the
          service is complete, we provide confirmation in your online portal.
        </p>
      </>
    ),
  },
  {
    title: "How do I pay for my home emergency cover?",
    desc: "Payment for your WeCare cover can be conveniently made through monthly direct debit. The initial payment is processed two weeks after the initiation of your plan, and then monthly on or around the same date each month thereafter.",
  },
];
export const findmorcards1 = [
  {
    sel: "Current WeCare Cover",
    img: gzr,
    title: "WeCare Boiler",
    ser: "Boiler",
    working: ["Boiler Breakdown"],
    notworking: [
      "Annual Boiler Service",
      "Central Heating System",
      "Plumbing",
      "Drainage",
      "Electrics",
      "Security",
      "Pest Control",
      "Security",
      "Pest Control",
    ],
    month: "Monthly Price",
    price: "£15.00",
    desc: "The initial direct debit payment will be requested in the upcoming 14 days. Your policy agreement spans a duration of 12 months.",
    serv: "Service Fee",
    fee: "£00.00",
    desc1:
      "The service fee is the charge incurred each time you seek a repair. You have the flexibility to select a plan with or without a service request fee. Opting for a higher service request fee lowers your monthly payments.",
  },
];

export const findmorcards2 = [
  {
    sel: "Current WeCare Cover",
    img: gzr,
    title: "WeCare Boiler",
    ser: "Boiler Service included",
    working: ["Boiler Breakdown", "Annual Boiler Service"],
    notworking: [
      "Central Heating System",
      "Plumbing",
      "Drainage",
      "Electrics",
      "Security",
      "Pest Control",
    ],
    month: "Monthly Price",
    price: "£18.00",
    desc: "The initial direct debit payment will be requested in the upcoming 14 days. Your policy agreement spans a duration of 12 months.",
    serv: "Service Fee",
    fee: "£00.00",
    desc1:
      "The service fee is the charge incurred each time you seek a repair. You have the flexibility to select a plan with or without a service request fee. Opting for a higher service request fee lowers your monthly payments.",
  },
];
export const findmorcards3 = [
  {
    sel: "Current WeCare Cover",
    img: gzr,
    title: "WeCare Heating",
    ser: "Complete Heating System",
    working: [
      "Boiler Breakdown",
      "Annual Boiler Service",
      "Central Heating System",
    ],
    notworking: [
      "Plumbing",
      "Drainage",
      "Electrics",
      "Security",
      "Pest Control",
    ],
    month: "Monthly Price",
    price: "£23.00",
    desc: "The initial direct debit payment will be requested in the upcoming 14 days. Your policy agreement spans a duration of 12 months.",
    serv: "Service Fee",
    fee: "£00.00",
    desc1:
      "The service fee is the charge incurred each time you seek a repair. You have the flexibility to select a plan with or without a service request fee. Opting for a higher service request fee lowers your monthly payments.",
  },
];
export const findmorcards4 = [
  {
    sel: "Current WeCare Cover",
    img: gzr,
    title: "WeCare Home",
    ser: "Complete Home Cover",
    working: [
      "Boiler Breakdown",
      "Annual Boiler Service",
      "Central Heating System",
      "Plumbing",
      "Drainage",
      "Electrics",
      "Security",
      "Pest Control",
    ],
    month: "Monthly Price",
    price: "£18.00",
    desc: "The initial direct debit payment will be requested in the upcoming 14 days. Your policy agreement spans a duration of 12 months.",
    serv: "Service Fee",
    fee: "£00.00",
    desc1:
      "The service fee is the charge incurred each time you seek a repair. You have the flexibility to select a plan with or without a service request fee. Opting for a higher service request fee lowers your monthly payments.",
  },
];

const token = Cookies.get("token");
export const fetchPlans = async () => {
  const tokens = Cookies.get("token");
  try {
    const response = await fetch(`${API_BASE_URL}/plans/user-plans/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${tokens}`,
      },
    });
    console.log(response, "fetchPlans, fetchPlans");

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    console.log(data, "datadata");
    return data.map((item) => ({
      sel: "Current WeCare Cover",
      img: null,
      title: item.plan.plan_type,
      ser: item.plan.tagline,
      working: item.plan.workings.replace(/\r\n/g, "").trim().split(","),
      notworking: item.plan.noworkings
        ? item.plan.noworkings.replace(/\r\n/g, "").trim().split(",")
        : [],
      month: "Monthly Price",
      price: `£${item.plan.monthly_price}`,
      desc: `The initial direct debit payment will be requested in the upcoming 14 days. Your policy agreement spans a duration of 12 months.`,
      serv: "Service Fee",
      fee: item.plan.fee,
      desc1: `The service fee is the charge incurred each time you seek a repair. You have the flexibility to select a plan with or without a service request fee. Opting for a higher service request fee lowers your monthly payments.`,
    }));
  } catch (error) {
    console.error("Error fetching plans:", error);
    return [];
  }
};

const fetchDataById = async (id) => {
  try {
    const response = await fetch(`${API_BASE_URL}/plans/plans/${id}/`);
    if (!response.ok) {
      throw new Error("Failed to fetch plan data");
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching plan data:", error);
    return null;
  }
};

const fetchData = async (id, setFindMorCards) => {
  try {
    const data = await fetchDataById(id);
    console.log("wuuiweyqwiueyqweuiqwyewuiyeqiwueyi id is: ", id);

    if (data !== null) {
      const updatedData = {
        sel: data.tagline,
        img: gzr,
        title: `WeCare ${data.plan_type}`,
        ser: data.category,
        documents: data.term_condition,
        working: data.workings.replace(/\r\n/g, "").trim().split(","),
        notworking: data.noworkings
          ? data.noworkings.replace(/\r\n/g, "").trim().split(",")
          : [],
        month: "Monthly Price",
        price: `£${parseFloat(data.monthly_price).toFixed(2)}`,
        isFixedPrice: data.is_fixed_price,
        desc: "The initial direct debit payment will be requested in the upcoming 14 days. Your policy agreement spans a duration of 12 months.",
        serv: "Service Fee",
        fee: data.fee,
        desc1:
          "The service fee is the charge incurred each time you seek a repair. You have the flexibility to select a plan with or without a service request fee. Opting for a higher service request fee lowers your monthly payments.",
      };

      setFindMorCards([updatedData]);

    } else {
      console.error("Error: Data from backend is null");
      return null;
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

export default fetchData;

async function fetchDataFromBackend(category, fee) {
  try {
    var url = `${API_BASE_URL}/plans/plans/?category=${category}`;

    if (fee) {
      url = `${url}&fee=${fee}`;
    }

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error("Failed to fetch plan data");
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching plan data:", error);
    return [];
  }
}

const cardsStapsNewBoiler = await fetchDataFromBackend("NewBoiler");
const serviceCard = await fetchDataFromBackend("BoilerService");
const dataRepair = await fetchDataFromBackend("RepairCover");

const cardsStapsData = await fetchDataFromBackend("Homeowner", "£0.00");
const cardsStapsData1 = await fetchDataFromBackend("Homeowner", "£60.00");
// const cardsStapsData2 = await fetchDataFromBackend("Homeowner", "£95.00");

const cardsLanloardsData = await fetchDataFromBackend("Landlord", "£0.00");
const cardsLanloardsData1 = await fetchDataFromBackend("Landlord", "£60.00");
// const cardsLanloardsData2 = await fetchDataFromBackend("Landlord", "£95.00");

console.log(cardsStapsData, cardsStapsData1, "hellow");
console.log(
  cardsLanloardsData,
  cardsLanloardsData1,
  "hellow"
);

// Home Land with filter 0
export const CardsStaps00 = cardsStapsData.map((plan) => ({
  id: plan.id,
  title: plan.plan_type,
  caption: plan.tagline,
  price: [`£${parseFloat(plan.monthly_price).toFixed(2)}`],
  working: plan.workings.replace(/\r\n/g, "").trim().split(","),
  notworking: plan.noworkings
    ? plan.noworkings.replace(/\r\n/g, "").trim().split(",")
    : [],
}));

// homeland with filter 60
export const CardsStaps001 = cardsStapsData1.map((plan) => ({
  id: plan.id,
  title: plan.plan_type,
  caption: plan.tagline,
  price: [`£${parseFloat(plan.monthly_price).toFixed(2)}`],
  working: plan.workings.replace(/\r\n/g, "").trim().split(","),
  notworking: plan.noworkings
    ? plan.noworkings.replace(/\r\n/g, "").trim().split(",")
    : [],
}));
// homeland with filter 90
// export const CardsStaps002 = cardsStapsData2.map((plan) => ({
//   id: plan.id,
//   title: plan.plan_type,
//   caption: plan.tagline,
//   price: [`£${parseFloat(plan.monthly_price).toFixed(2)}`],
//   working: plan.workings.replace(/\r\n/g, "").trim().split(","),
//   notworking: plan.noworkings
//     ? plan.noworkings.replace(/\r\n/g, "").trim().split(",")
//     : [],
// }));

// Landlord filters
export const Cardslanloards00 = cardsLanloardsData.map((plan) => ({
  id: plan.id,
  title: plan.plan_type,
  caption: plan.tagline,
  price: [`£${parseFloat(plan.monthly_price).toFixed(2)}`],
  working: plan.workings.replace(/\r\n/g, "").trim().split(","),
  notworking: plan.noworkings
    ? plan.noworkings.replace(/\r\n/g, "").trim().split(",")
    : [],
}));

export const Cardslanloards001 = cardsLanloardsData1.map((plan) => ({
  id: plan.id,
  title: plan.plan_type,
  caption: plan.tagline,
  price: [`£${parseFloat(plan.monthly_price).toFixed(2)}`],
  working: plan.workings.replace(/\r\n/g, "").trim().split(","),
  notworking: plan.noworkings
    ? plan.noworkings.replace(/\r\n/g, "").trim().split(",")
    : [],
}));

// export const Cardslanloards002 = cardsLanloardsData2.map((plan) => ({
//   id: plan.id,
//   title: plan.plan_type,
//   caption: plan.tagline,
//   price: [`£${parseFloat(plan.monthly_price).toFixed(2)}`],
//   working: plan.workings.replace(/\r\n/g, "").trim().split(","),
//   notworking: plan.noworkings
//     ? plan.noworkings.replace(/\r\n/g, "").trim().split(",")
//     : [],
// }));

export const cardsStapNewBoiler00 = cardsStapsNewBoiler.map((plan) => ({
  id: plan.id,
  title: `WeCare ${plan.plan_type}`,
  caption: plan.tagline,
  category: plan.category,
  price: [`£${parseFloat(plan.monthly_price).toFixed(2)}`],
  working: plan.workings.replace(/\r\n/g, "").trim().split(","),
  notworking: plan.noworkings
    ? plan.noworkings.replace(/\r\n/g, "").trim().split(",")
    : [],
}));

export const dataRepair00 = dataRepair.map((plan) => ({
  id: plan.id,
  title: `WeCare ${plan.plan_type}`,
  caption: plan.tagline,
  price: [`£${parseFloat(plan.monthly_price).toFixed(2)}`],
  working: plan.workings.replace(/\r\n/g, "").trim().split(","),
  isFixedPrice: plan.is_fixed_price,
  notworking: plan.noworkings
    ? plan.noworkings.replace(/\r\n/g, "").trim().split(",")
    : [],
}));

console.log("dataRepair00", dataRepair00);

export const serviceCard00 = serviceCard.map((plan) => ({
  id: plan.id,
  title: `WeCare ${plan.plan_type}`,
  caption: plan.tagline,
  price: [`£${parseFloat(plan.monthly_price).toFixed(2)}`],
  working: plan.workings.replace(/\r\n/g, "").trim().split(","),
  notworking: plan.noworkings
    ? plan.noworkings.replace(/\r\n/g, "").trim().split(",")
    : [],
}));

// fetching Data for Dashboard:

// Payment Details

export const fetchPayment = async (
  setAccountHolderName,
  setAccountNumber,
  setSortCode
) => {
  try {
    const url = `${API_BASE_URL}/customer/payment/`;
    const token = Cookies.get("token");
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.data && response.data.length > 0) {
      const { account_holder_name, account_number, sort_code } =
        response.data[0];
      setAccountHolderName(account_holder_name);
      setAccountNumber(account_number);
      setSortCode(sort_code);
    } else {
      console.error("Error: No payment data received from the backend");
    }
  } catch (error) {
    console.error("Error fetching payment data:", error);
  }
};

// Content Details:

export const fetchContact = async (
  setFirstName,
  setSurname,
  setEmail,
  setPhoneNumber,
  setPostCode,
  setAddress
) => {
  try {
    const url = `${API_BASE_URL}/customer/contact/`;
    const token = Cookies.get("token");
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.data && response.data.length > 0) {
      const data = response.data[0];
      setFirstName(data.first_name);
      setSurname(data.surname);
      setEmail(data.email);
      setPhoneNumber(data.phone_number);
      setPostCode(data.post_code);
      setAddress(data.address);
    } else {
      console.error("Error: No contact data received from the backend");
    }
  } catch (error) {
    console.error("Error fetching contact data:", error);
  }
};
// Boiler Details

// export const fetchBoiler = async (setBoilerDetails) => {
//   try {
//       const url = `${API_BASE_URL}/customer/boiler/`;
//       const token = Cookies.get('token');
//       const response = await axios.get(url, {
//           headers: {
//               Authorization: `Bearer ${token}`
//           }
//       });

//       if (response.data && response.data.length > 0) {
//           const data = response.data[0];
//           console.log(data.boiler_details, 'datafrombackend');
//           setBoilerDetails(data.boiler_details);
//       } else {
//           console.error('Error: No boiler data received from the backend');
//       }
//   } catch (error) {
//       console.error('Error fetching boiler data:', error);
//   }
// };

export const cards = [
  {
    title: "Heating Cover",
    img: gzr,
  },
  {
    title: (
      <>
        Home<span style={{ color: "#604CD4" }}>+</span>
      </>
    ),
    img: cardimg1,
  },
  {
    title: (
      <>
        Complete<span style={{ color: "#604CD4" }}>+</span>
      </>
    ),
    img: cardimg3,
  },
];
export const imges = [
  {
    img: logo1,
  },
  {
    img: logo2,
  },
  {
    img: logo3,
  },
  {
    img: logo4,
  },
  {
    img: logo5,
  },
  {
    img: logo6,
  },
  {
    img: logo8,
  },
  {
    img: logo7,
  },

  {
    img: logo9,
  },
  {
    img: logo10,
  },
  {
    img: logo11,
  },
  {
    img: logo12,
  },
];

export const CookiesData = [
  {
    title: "WeCare Website Cookies Policy",
    desc: (
      <>
        This policy explains how cookies are used on our website and how they
        may impact your experience while browsing or purchasing from us.
      </>
    ),
  },
  {
    title: "What Are Website Cookies?",
    desc: (
      <>
        Cookies are small data files sent from a website and stored on your
        computer's hard drive as text files. This happens while you're browsing
        a website. Cookies perform various functions on a website, and most are
        unobtrusive and harmless. They cannot carry viruses or install malware
        on your device.
      </>
    ),
  },
  {
    title: "How Does WeCare Use Cookies?",
    desc: (
      <>
        We use a variety of cookies to gather information about visitors to our
        website. This includes data such as the number of visitors to each page
        and whether you arrived at our site through a search engine like Google
        or Bing.
      </>
    ),
  },
  {
    title: "Cookies and Your Privacy",
    desc: (
      <>
        Cookies help us collect information about visitors in an anonymous
        manner. If we need to collect personal information that could identify
        you, we will do so in a clear and transparent way, explaining how we
        intend to use your information. For more details, please refer to our
        Privacy Policy.
      </>
    ),
  },
  {
    title: "How to Manage Your Cookie Preferences",
    desc: (
      <>
        You have full control over your cookie preferences for every website you
        visit. You can adjust your cookie settings by following the instructions
        below. If your browser isn't listed, please consult the 'Help' section
        in your browser.
      </>
    ),
  },
  {
    title: (
      <>
        <h1>
          <strong>Browse</strong>
        </h1>
        <strong>Editing Your Cookie Preference</strong> <br /> <br />
        <strong>Google Chrome</strong>
      </>
    ),
    desc: (
      <>
        Click the wrench icon on the toolbar 2. Select “Settings” 3. Click “Show
        Advanced Settings” 4. Under “Privacy,” click “Content Settings” 5. In
        the “Cookies” section, you can: Delete cookies, Block cookies by
        default, Allow cookies by default, Make exceptions for specific sites or
        domains
      </>
    ),
  },
  {
    title: (
      <>
        <strong>Internet Explorer 7+</strong>
      </>
    ),
    desc: (
      <>
        Go to the “Tools” menu and select “Internet Options” 2. Choose the
        “Privacy” tab 3. Adjust the slider to your preferred level of privacy 4.
        For more options, click “Advanced” and check the “Override automatic
        cookie handling” box, then customize your settings
      </>
    ),
  },
  {
    title: (
      <>
        <strong>Firefox</strong>
      </>
    ),
    desc: (
      <>
        Open the “Tools” menu and select “Options” 2. Choose the “Privacy” tab
        3. If available, select the cookies option, or choose “Use custom
        settings for history” from the “Firefox will” dropdown menu 4. Set your
        desired cookie preferences
      </>
    ),
  },
  {
    title: "Important Considerations",
    desc: (
      <>
        Disabling cookies may prevent you from using interactive features on our
        website. By removing certain cookies, you might miss out on offers and
        advertisements tailored to your interests.
      </>
    ),
  },
  {
    title: "Further Information",
    desc: (
      <>
        For more details on cookies and how to manage or delete them on your
        computer, visit{" "}
        <span>
          <a
            href="https://www.aboutcookies.org.uk"
            className="blue-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.aboutcookies.org.uk
          </a>
        </span>
        .
      </>
    ),
  },
];

export const Termsdata = [
  {
    title: "Terms & Conditions",
    desc: (
      <>
        Below are the terms and conditions that apply to the use of{" "}
        <strong>
          <a
            target="_blank"
            className="wecareboilerrepairlink"
            href="http://www.wecareboilerrepair.com"
          >
            www.wecareboilerrepair.com
          </a>
        </strong>
        <br />
        <br />
        This website is owned and operated by WeCare Boiler Repair Ltd,
        registered in England & Wales. Reg No: 09699907. Registered Office:{" "}
        <strong>
          WeCare Boiler Repair Ltd, 30 The Loont, Winsford, Cheshire, CW7 1EU
        </strong>
        . VAT Reg No: 15125992.
        <br />
        <br />
        ‘Us, ‘we’ or ‘our’ means ‘WeCare Boiler Repair Ltd. ‘You’ & ‘Your’ means
        you, the visitor and user of our ‘Website’
      </>
    ),
  },
  {
    title: "Website Terms",
    desc: (
      <>
        You should read these terms and conditions along with our Privacy Policy
        (collectively ‘Website Terms’) before using our Website. If you don’t
        accept the Website Terms, don’t use our Website. By using our Website,
        you are confirming that you have read and agree to the Website Terms.
        <br />
        <br />
        If you want the Website Terms on paper, you can print them at any time.
      </>
    ),
  },
  {
    title: "Provider Terms",
    desc: (
      <>
        Products and services that you purchase from our Website maybe provided
        by us, other companies owned by us or 3rd party companies over whom we
        do not have control. All products and services have separate applicable
        terms and conditions of their own (Providers Terms). By purchasing a
        product or service from our Website you are confirming that you have
        read and agree to the Providers Terms. If the Website Terms in any way
        contradict the Providers Terms, then the Providers Terms will apply.
        <br />
        <br />
        Before you purchase any product or service from our Website you should
        read the accompanying Providers Terms and any other documentation that
        applies to the Product or service.
      </>
    ),
  },
  {
    title: "Changes to the Website Terms",
    desc: (
      <>
        We may make changes to the Website Terms from time to time. It is your
        responsibility to regularly read the Website Terms and make sure you are
        aware of any changes. If you use our website after we have made any
        changes you are confirming that you accept and agree to the changes.
      </>
    ),
  },
  {
    title: "Information on our Website",
    desc: (
      <>
        Neither we nor any third parties provide any warranty or guarantee as to
        the accuracy, timeliness, performance, completeness or suitability of
        the information and materials found or offered on this website for any
        particular purpose. You acknowledge that such information and materials
        may contain inaccuracies or errors and we expressly exclude liability
        for any such inaccuracies or errors to the fullest extent permitted by
        law.
        <br />
        <br />
        Your use of any information or materials on this website is entirely at
        your own risk, for which we shall not be liable. It shall be your own
        responsibility to ensure that any products, services or information
        available through this website meet your specific requirements.
      </>
    ),
  },
  ,
  {
    title: "Permission to use our Website and its content",
    desc: (
      <>
        This website contains material which is owned by or licensed to us. This
        material includes, but is not limited to, the design, layout, look,
        appearance and graphics. Reproduction is prohibited other than in
        accordance with the copyright notice, which forms part of these terms
        and conditions.
        <br />
        <br />
        All trademarks reproduced in this website which are not the property of,
        or licensed to, the operator is acknowledged on the website.
        <br />
        <br />
        Unauthorised use of this website may give rise to a claim for damages
        and/or be a criminal offence.
      </>
    ),
  },
  {
    title: "Third-party sites and content",
    desc: (
      <>
        From time to time this website may also include links to other websites.
        These links are provided for your convenience to provide further
        information. They do not signify that we endorse the website(s). We have
        no responsibility for the content of the linked website(s).
      </>
    ),
  },
  {
    title: "Availability of our products and services",
    desc: (
      <>
        Our products and services are available to Homeowners and private
        landlords for domestic properties located in mainland England, Wales and
        Scotland.
      </>
    ),
  },
  {
    title: "Disclaimer",
    desc: (
      <>
        The information contained in this website is for general information
        purposes only. The information is provided by WeCare Boiler Repair Ltd
        and while we endeavour to keep the information up to date and correct,
        we make no representations or warranties of any kind, express or
        implied, about the completeness, accuracy, reliability, suitability or
        availability with respect to the website or the information, products,
        services, or related graphics contained on the website for any purpose.
        Any reliance you place on such information is therefore strictly at your
        own risk.
        <p className="p_top p_bot">
          In no event will we be liable for any loss or damage including without
          limitation, indirect or consequential loss or damage, or any loss or
          damage whatsoever arising from loss of data or profits arising out of,
          or in connection with, the use of this website.
        </p>
        Through this website you can link to other websites which are not under
        the control of WeCare Boiler Repair Ltd. We have no control over the
        nature, content and availability of those sites. The inclusion of any
        links does not necessarily imply a recommendation or endorse the views
        expressed within them.
        <p className="p_top">
          Every effort is made to keep the website up and running smoothly.
          However, WeCare Boiler Repair Ltd takes no responsibility for, and
          will not be liable for, the website being temporarily unavailable due
          to technical issues beyond our control.
        </p>
      </>
    ),
  },
  {
    title: "Legal compliance and applicable law",
    desc: (
      <>
        Your use of this website and any dispute arising out of such use of the
        website is subject to the laws of England, Northern Ireland, Scotland
        and Wales.
      </>
    ),
  },
];
export const Privacydata = [
  {
    title: "How We Use Your Information",
    desc: (
      <>
        When you buy a product or service from us, we will collect some of your
        personal details to make sure you have everything you need to make the
        most of our services. Please be assured that we’ll only use this for
        administering your contract and to support the delivery of the services
        or products you’ve requested.
        <p className="p_top p_bot">
          {" "}
          Examples of the types of personal information we usually collect are:
        </p>
        <ul className="ul_about">
          <li>Name</li>
          <li>Address</li>
          <li>Telephone number (including mobile)</li>
          <li>Email address</li>
          <li>Payment details (Direct Debit, (credit/debit card number)</li>
          <li>Property type (flat, house etc.)</li>
          <li>Boiler details (make and model)</li>
          <li>
            Any additional requirements, such as large print or Braille
            documentation
          </li>
          <li>
            Details of any additional authorised parties who can manage your
            requirements on your behalf.
          </li>
        </ul>
        <p className="p_top p_bot">
          The information requested during the application process is required
          to complete the sale of the product and/or service on offer, and forms
          part of your contract with us
        </p>
        Unless otherwise stated, the information you provide will never be used
        for any other purpose without your permission. If any of the data is
        missing from the application form, or is incorrect, we may not be able
        to process your request.
      </>
    ),
  },
  {
    title: "Keeping and Storing Your Data",
    desc: (
      <>
        If you’re a current or past customer, we’ll keep a copy of your personal
        details for no longer than six years, from the time your active
        relationship with us ends. Holding on to data allows us to keep accurate
        records for tax purposes and to handle any future complaints. All other
        personal data used for prospecting and quotation requests is kept for a
        maximum of 90 days, unless otherwise required by law.
      </>
    ),
  },
  {
    title: "Using Information Provided by Third Parties",
    desc: (
      <>
        We sometimes use data from third parties or publicly available sources
        (such as Experian), the edited electoral roll or the deceased preference
        service. Using this data helps us to ensure that our records are
        accurate and up to date by filling in any gaps on an address or
        clarifying addresses and house numbers. It also allows us to remove
        anyone from our mailings that has passed away.
        <p className="p_top">
          We also use data for marketing purposes. Any data we use in this way
          is thoroughly checked by both the supplier and our own internal teams
          to ensure that the correct marketing permissions are in place and that
          the data is being used fairly.
        </p>
      </>
    ),
  },
  {
    title: "Sharing Your Data with Third Parties",
    desc: (
      <>
        We often work with a small number of carefully selected third parties
        who introduce us to their customers, so we can promote the products and
        services we offer.
        <p className="p_top p_bot">
          If you’ve been introduced to us through one of our partners, we may
          share with them details of the products and services you’ve purchased.
          Sharing data in this way helps us resolve individual and ensures that
          we’re offering the right products, to the right people.
        </p>
        We respect your privacy and that’s why we don’t give your data to any
        third parties for marketing purposes. However, on occasion and in
        addition to the above, we may pass your information to a limited number
        of third parties for the following reasons:
        <ul className="ul_about p_top">
          <li>
            To deliver the services you’ve asked for, which might include giving
            information to members of your family, household, or other people
            who have an interest in the property; for instance, landlords or
            letting agents
          </li>
          <li>For legal or regulatory purposes including fraud prevention</li>
          <li>If we buy or sell any business or company assets.</li>
        </ul>
      </>
    ),
  },
  {
    title: "We’ll Always Keep You Informed",
    desc: (
      <>
        Whenever we collect your personal information we’ll give you the
        opportunity to let us know how you’d like us to get in touch in the
        future. We promise not to inundate you with marketing messages and we
        understand if you would prefer not to receive any from us.
        <p className="p_top p_bot">
          If you’ve consented to us sending you marketing messages, you can
          change your mind at any time by contacting us using the details in the
          Contact Us section. You’ll also find an unsubscribe link at the bottom
          of every marketing email we send you.
        </p>
        If you’ve given us an email address, you may receive email messages
        related to the management of your policy, including policy and renewal
        documents. If you’d prefer not to receive these messages in this way,
        just let us know and we’ll be happy to provide them in paper form
        instead (an administration fee will be charged for this service).
      </>
    ),
  },
  {
    title: "Your Rights",
    desc: (
      <>
        If you’d like to see the personal information that we hold about you,
        you can request a copy at any time. If you find that this information is
        incorrect you can ask for it to be updated. Or, if you believe the
        information is being processed without a legal basis, you can ask us to
        stop or request that it is deleted from our systems.
        <p className="p_top">
          To action any of the above, send an email to our Privacy Team at
          info@wecare.com alternatively, you can write to us at WeCare Boiler
          Repair Ltd, <strong>(Address Here)</strong>.
        </p>
        <p className="p_top">
          We won’t ever charge you for a copy of your personal data, but we may
          ask you for proof of your identity before we disclose any information.
          Once we’ve seen this, we’ll send you a copy of the personal data we
          hold within 30 days.
        </p>
      </>
    ),
  },
  {
    title: "Customer Profiles",
    desc: (
      <>
        We carry out customer profiling so we can understand the needs,
        behaviours and socio-demographic characteristics of our customers. This
        helps us to make sure that we are offering relevant products and
        services to people; for example, not offering gas products to people
        without a gas supply. Profiling also means we can tailor our offerings
        to current customers, enhancing the potential benefits of being a
        customer.
      </>
    ),
  },
  {
    title: "Links to Other Websites",
    desc: (
      <>
        Our website may contain links to other websites of interest. However,
        once you have used these links to leave our site, you should note that
        we do not have any control over those other websites. Therefore, we
        cannot be responsible for the protection and privacy of any information
        which you provide whilst visiting such sites, and such sites are not
        governed by this privacy statement. You should exercise caution and look
        at the privacy statement applicable to the website in question.
      </>
    ),
  },
  {
    title: "Contact Us",
    desc: (
      <>
        <p className="p_bot">
          You can contact us by mail, email or telephone at the following:
        </p>

        <ul className="ul_about">
          <li>
            WeCare Boiler Repair Ltd,{" "}
            <strong>
              WeCare Boiler Repair Ltd,30 The Loont,Winsford,Cheshire,CW7 1EU
            </strong>
            .
          </li>
          <li>Email: info@wecareboilerrepair.com</li>
          <li>
            Telephone: <strong>03301114442</strong>
          </li>
        </ul>
      </>
    ),
  },
];
export const Faqsaccording1 = [
  {
    title: "What are your opening hours?",
    desc: (
      <>
        <p className="p_bot">Our opening hours are: </p>
        Customer Service: 8:30 AM – 5:30 PM, Monday to Friday (Emergency
        call-out only, weekends and public hoidays)
        <p className="p_top p_bot">
          Sales: 8:30 AM – 5:30 PM, Monday to Friday (Emergency call-out only,
          weekends and public hoidays)
        </p>
        General Repairs: 8:30 AM – 5:30 PM, Monday to Friday (Emergency call-out
        only, weekends and public hoidays)
        <p className="p_top">
          Emergency Repairs: Available 24/7, all year-round
        </p>
      </>
    ),
  },
  {
    title:
      "Is it possible for me to choose a future start date for my plan if I sign up today?",
    desc: "Absolutely! During the checkout process you will have the option to select the date you wish your service agreement to start. Please note: your initial payment will be taken around 14 days after your selected start date. This will then be followed by a further 11 monthly payments taken on or around the same date as your initial payment.",
  },
  {
    title: "Is your call center based in the UK?",
    desc: "Yes, our 24 hour call centre and head office are both based in the UK.",
  },
  {
    title: "When does my plan start if I sign up today?",
    desc: (
      <>
        <p className="p_bot">
          Your WeCare plan starts from the day you sign-up. If you are taking
          out a service plan for the first time, you will not be able to book
          repairs for faults that occur within the first 14 days of joining us.
        </p>
      </>
    ),
  },
  {
    title:
      "Can I speak to someone over the phone if I'm interested in signing up?",
    desc: (
      <>
        Yes! The WeCare team is here to assist you and ensure you’re set up with
        the right service and support tailored to your needs.
        <div className="p_top">
          Customer Service: 8:30 AM – 5:30 PM, Monday to Friday (Emergency
          call-out only, weekends and public hoidays)
          <p className="p_top p_bot">
            Sales: 8:30 AM – 5:30 PM, Monday to Friday (Emergency call-out only,
            weekends and public hoidays)
          </p>
          General Repairs: 8:30 AM – 5:30 PM, Monday to Friday (Emergency
          call-out only, weekends and public hoidays)
          <p className="p_top">
            Emergency Repairs: Available 24/7, all year-round
          </p>
        </div>
      </>
    ),
  },
  {
    title:
      "I left my previous provider a few weeks ago, what is the exclusion period?",
    desc: "14 days.",
  },
  {
    title: "Do you use your own team of engineers for to carry out repairs?",
    desc: "Yes 90% of the time. However, we can most effectively deliver our optimum service by using our extensive network of engineers from the following: Key boiler manufacturers – this ensures we can fix over 95% of their boiler breakdowns on the first visit Key account – this ensures we can deliver a rapid emergency plumbing and drains response within the WeCare service area, 24/7/365 Throughout the WeCare repair network, all our engineers are fully Gas Safe certified",
  },
  {
    title: "Are WeCare engineers fully vetted and approved?",
    desc: (
      <>
        Certainly, our rigorous vetting process upholds the highest standards
        for our WeCare engineers. We:
        <p className="p_top">
          Conduct audits and inspections upon job completion <br />
          Verify the possession of valid Public Liability Insurance <br />
          Examine their pertinent trade qualifications, including their Gas
          Safe® Registration, ensuring they are fully qualified for your repair{" "}
          <br />
          Establish service level agreements to meet your expectations <br />
          Enforce compliance with Health and Safety regulations
        </p>
      </>
    ),
  },
  {
    title: "What happens after I have signed up to my WeCare plan?",
    desc: (
      <>
        <p className="p_bot">
          After registering, you will receive an email containing your login
          credentials for our client dashboard. Please log in and input as many
          details about your boiler as you can. The more information you
          provide, the faster and more efficiently we can handle any future
          repairs. Once completed, you can simply sit back and relax.
        </p>
        Within the WeCare platform, you have the option to download and view
        your WeCare Terms of Service Agreement, update your personal detials. We
        advise doing this upon your initial login, as it provides comprehensive
        information about your service agreement and instructions on how to
        reach out to us.
      </>
    ),
  },
  {
    title: "How long does the WeCare agreement last?",
    desc: (
      <>
        Our agreements have a minimum duration of 12 months, ensuring your
        commitment to us is limited to a year at a time. However, at WeCare, we
        offer you the flexibility to lock in your monthly price for up to 3
        years, providing peace of mind regardless of the number of repairs you
        may need. Regardless of whether you choose a 1, 2, or 3-year Fixed Price
        Term, your Contract Term remains at 12 months.
        <p className="p_top p_bot">
          Approximately 30 days before the conclusion of your Fixed Price Term,
          you will receive an email notifying you of your renewal price. Please
          ensure that your email address is up to date in your customer portal.
          (Note: Occasionally, email filters may redirect this email to your
          spam folder, so be sure to check.)
        </p>
        If we do not receive any communication from you within those 30 days,
        your contract will automatically renew for an additional 12 months. In
        case you decide to cancel the policy after receiving the renewal notice,
        please call us at (contact number here), option 3.
        <p className="p_top">
          Kindly note that canceling your direct debit does not terminate the
          contract.
        </p>
      </>
    ),
  },
  {
    title: "Is there a call-out fee if I book a WeCare repair?",
    desc: "Upon signing up, you have the option to select a plan with or without a call-out fee for each repair. Opting for a call-out fee will reduce your monthly charges, but you will need to pay the agreed fixed fee each time you schedule a repair.",
  },
  {
    title:
      "Would it be possible to receive a physical copy of my WeCare policy documents?",
    desc: "Since we operate as a paperless company, at the moment, we are unable to dispatch policy documents through postal mail. However, you can easily access and view them on our website and within your online portal once you've completed the sign-up process with WeCare.",
  },
];
export const Faqsaccording2 = [
  {
    title: "I have an old boiler, will you still repair it?",
    desc: "Certainly, we will maintain and repair boilers of any age, as long as the parts are still available and the boiler was in good working condition when you signed-up.",
  },
  {
    title: "What occurs if your engineers are unable to fix my boiler?",
    desc: "Assuming your boiler is in satisfactory working order at the time of enrollment, the likelihood of us being unable to repair it in case of a breakdown is minimal. However, in the event that your boiler, under seven years old, is considered beyond economical repair, we will cover the replacement cost up to a maximum value of £2,500. For boilers over seven years old, subject to availability, we might offer a discounted fixed-price replacement boiler as part of a new 12-month minimum term service agreement or contribute towards the cost of a new boiler.",
  },
  {
    title:
      "My boiler is over seven years old, what happens if you cannot repair it?",
    desc: "Assuming your boiler is in satisfactory working condition at the time of enrollment, the chances of us being unable to repair it in case of a breakdown are minimal. However, if it is deemed beyond economical repair, we might, subject to availability, provide a discounted fixed-price replacement boiler as part of a new 12-month minimum term service agreement or contribute towards the cost of a new boiler.",
  },
  {
    title: "Do your cover plans apply to all makes and models of boiler?",
    desc: "We provide maintenance and repair services for all types and brands of residential natural gas boilers, excluding Potterton Powermax, Chaffoteaux, Sime, and Elm Le Blanc models. Our services do not cover thermal store boilers, solid fuel boilers, oil boilers, electric boilers, back boilers, or dual-purpose boilers.",
  },
  {
    title: "Do your plans cover back boilers?",
    desc: "Currently, we do not offer this service, but it may be considered in the future",
  },
  {
    title: "Do your plans cover oil fuelled boilers?",
    desc: "No, our services are limited to boilers and systems powered by natural mains gas and LPG.",
  },
  {
    title: "Do your plans cover LPG (bottled gas) powered boilers?",
    desc: "Yes, but specifically for bulk tank installations only. ",
  },
  {
    title: "Do your plans cover floor standing boilers?",
    desc: "Yes, we provide services for both wall-hung and floor-standing boilers",
  },
];
export const Faqsaccording3 = [
  {
    title: "When will my boiler be serviced?",
    desc: (
      <>
        We conduct complimentary annual boiler services from March to September,
        near the anniversary of your plan's commencement. This scheduling aims
        to maintain swift emergency response times during the busier winter
        months.
        <p className="p_top">
          A month before the annual services in your region, we will reach out
          to coordinate a convenient day for the appointment. Be assured that if
          your service is overdue, it won't impact your support or the ability
          to book repairs through our 24/7 online customer portal.
        </p>
      </>
    ),
  },
  {
    title:
      "Does the plan cover an annual boiler service, and is it conducted each year?",
    desc: " Certainly, it is provided every year, and you are eligible for an annual boiler service throughout each year of your service agreement.",
  },
  {
    title: "Do I have to have my boiler serviced before I can sign-up?",
    desc: "No, as long as your boiler and central heating system were in satisfactory working condition without any pre-existing faults at the time of signing-up for your plan.",
  },
  {
    title: "Is it necessary to service or inspect my boiler beforehand?",
    desc: "No, once you have signed-up, the WeCare service agreement implies that your boiler and central heating system are in good working condition, with no pre-existing faults at the time of plan initiation.",
  },
];
export const Faqsaccording4 = [
  {
    title: "Is it possible to make monthly payments by direct debit?",
    desc: "Certainly, all our plans are settled through monthly direct debit.",
  },
  {
    title: "Is it possible to change my direct debit?",
    desc: (
      <>
        <p className="p_bot">
          If you'd like to modify the bank details for your direct debit, kindly
          contact us at (Contact number here) - Option 3.
        </p>
        Regrettably, we are unable to adjust the payment date.
      </>
    ),
  },
  {
    title: "Is it possible to pay annually instead of a monthly direct debit?",
    desc: "Currently, we only accept payments through monthly direct debit.",
  },
  {
    title:
      "How do your service plans compare to those offered by other providers?",
    desc: (
      <>
        While some competitors provide viable solutions, the specific features
        and offerings from various providers may vary over time. To guide your
        decision, we can share reasons our customers have chosen WeCare:
        <p className="p_top p_bot">
          Flexibility to fix your price for up to three years with a commitment
          to no more than a 12-month term at a time.
        </p>
        <p className="p_top p_bot">
          Designated WeCare service area with full coverage and swift response
          to emergencies.
        </p>
        High customer satisfaction
        <p className="p_top p_bot">
          Ability to service and repair boilers of any age
        </p>
        A UK-based call center for effective communication
      </>
    ),
  },
  {
    title: "What are the costs upon renewal?",
    desc: "We cannot predict future prices as they depend on external factors like inflation, tax rates, and operating costs. However, we are the only company in our sector that provides the option to lock in your price for up to three years.",
  },
  {
    title:
      "Is it possible to reduce the monthly cost by agreeing to pay a fixed fee per repair?",
    desc: "Certainly, we offer three options: either no call-out fee per repair or either a £60 or £95 call-out fee per repair. Opting for the £60 or £95 call-out fee per repair reduces your monthly payment, but you'll be required to pay the £60 or £95 fee each time you schedule a repair.",
  },
  {
    title: "Are there any discounts available for cover plans?",
    desc: "Our prices are already highly competitive, and we provide fixed-price plans for up to three years. We regularly review our prices and, at present, do not offer additional discounts.",
  },
];
export const Faqsaccording5 = [
  {
    title:
      "Can you explain the difference between an emergency and an urgent repair?",
    desc: (
      <>
        We categorize the loss of hot water as an urgent repair, and during the
        winter months (September - February), complete loss of heat is also
        treated as an urgent repair.
        <p className="p_top p_bot">
          Our goal is to address all urgent situations by the following working
          day, ensuring a prompt response when suppliers are open and parts are
          accessible
        </p>
        As per the terms and conditions of your agreement, an emergency
        situation is defined as a sudden and unforeseen escape of water or
        uncontrollable water leak that:
        <p className="p_top p_bot">
          Cannot be stopped by turning off the stop tap.
        </p>
        If left unattended until the following working day, would cause further
        damage to your property.
        <p className="p_top p_bot">
          Cannot be contained for at least seven hours by putting a container
          under the leak
        </p>
      </>
    ),
  },
  {
    title: "What is the maximum repair cost?",
    desc: "There is no cap on repair costs for any of our plans, as long as your appliance or system is not considered beyond economical repair.",
  },
  {
    title: "What are your typical response times when requesting a repair?",
    desc: "For emergency repairs, such as uncontrollable water leaks, our average response time is two hours. In the case of urgent repairs, addressing issues like loss of heat or hot water, our average response time is 12 hours. We strive to accommodate all other general repairs by scheduling them on a day and time slot that suits your preferences.",
  },
  {
    title:
      " Do you use new, authentic, manufacturer-approved components for repair purposes?",
    desc: "Yes, all parts used are brand new, genuine, and manufacturer approved, where applicable.",
  },
];
export const Faqsaccording6 = [
  {
    title: "What area do you cover?",
    desc: "We currently cover (what area do you cover?) as you aren't nationwide.",
  },
  {
    title: "What kinds of properties do you provide services for?",
    desc: "We provide services for all permanent residential properties, as long as they are used exclusively for domestic purposes.",
  },
  {
    title: "Do your plans cover for flats or apartments?",
    desc: (
      <>
        <p className="p_bot">
          Yes, we provided services for all types of permanent domestic
          properties
        </p>
      </>
    ),
  },
  {
    title: "Do your plans cover commercial properties?",
    desc: (
      <>
        <p className="p_bot">
          No, we only provide services for domestic properties.
        </p>
      </>
    ),
  },
  {
    title: "Do your plans cover mobile homes?",
    desc: (
      <>
        <p className="p_bot p_top">
          No, we only provide services for permanent dwellings that are used for
          domestic purposes
        </p>
      </>
    ),
  },
  {
    title: "Do your plans cover Saniflo toilets? ",
    desc: (
      <>
        <p className="p_bot p_top">
          No, Saniflo toilets are not covered by our service agreements; our
          services are limited to gravity drains only.
        </p>
      </>
    ),
  },
  {
    title: "Do your plans cover repairing and / or servicing gas fires?",
    desc: (
      <>
        <p className="p_top">
          No, our plans do not cover the repair or servicing of gas fires.
        </p>
      </>
    ),
  },
  {
    title: "Do your plans cover repairing and / or servicing gas cookers?",
    desc: (
      <>
        <p className="p_top">
          No, our plans do not cover the repair or servicing of gas cookers.{" "}
        </p>
      </>
    ),
  },
];
export const Faqsaccording7 = [
  {
    title: "Is it possible to update my contact details?",
    desc: (
      <>
        <p className="p_bot">
          The My Account section on our website gives your the option to easily
          manage your plan. Within the platform, you can update your contact
          details and review your service agreement.
        </p>
        Alternatively, if you prefer direct assistance, please don't hesitate to
        call us at (Contact number here), We're always here to assist you!
      </>
    ),
  },
  {
    title:
      "I have recently moved house, is it possible to change my address online?",
    desc: "To ensure your new property is covered by our service agreement, you will need to call us on (Contact number here) and one of our advisiors will process the change for you.",
  },
  {
    title: "Renewals",
    desc: (
      <>
        You will be sent an email 30 days prior to the conclusion of your
        agreement, providing details of your renewal price. It is crucial to
        maintain an updated email address in your customer portal. (Please be
        aware that email filters may occasionally redirect this message to your
        spam folder, so be sure to check.)
        <p className="p_top p_bot">
          Should we not receive any communication from you within this 30-day
          period, your contract will automatically renew for an additional 12
          months. If, upon receiving your renewal notice, you decide to cancel
          your service agreement, kindly contact us at (Contact number here),
          option 3.
        </p>
        Note that canceling your direct debit does not terminate your agreement.
      </>
    ),
  },
  {
    title: "Is it possible to update my marketing preferences?",
    desc: "For adjustments to your marketing preferences, such as opting out of marketing emails, direct mailings, and/or phone calls, please contact us at (Contact number here) to update your preferences accordingly",
  },
  {
    title: "How do I cancel my WeCare cover plan?",
    desc: (
      <>
        For inquiries about your plan, including cancellations, kindly contact
        our team of advisors (Contact number here).
        <p className="p_top p_bot">
          Refer to Section 3 of our Terms and Conditions for information on our
          cancellation process.
        </p>
        Important: Cancelling your direct debit does not terminate your
        agreement with us
      </>
    ),
  },
  {
    title: "What is your complaints procedure?",
    desc: (
      <>
        We are dedicated to enhancing our systems and procedures for the
        continual improvement of service quality. While we strive for
        excellence, we acknowledge that we may not always meet expectations.
        Your feedback, whether positive or negative, is valuable to us and is
        utilized constructively to refine our ongoing service levels.
        <p className="p_top">
          Explore our Complaints Procedure page for a comprehensive overview of
          our four-stage complaints handling process.
        </p>
      </>
    ),
  },
  {
    title:
      "The current plan holder's has pass away, how can I proceed to either cancel or transfer the service plan?",
    desc: (
      <>
        In the unfortunate event of the plan holder's demise, three options are
        available:
        <p className="p_bot p_top">
          If the policy/plan is no longer needed, we can assist with
          cancellation. To process the cancellation, we require a scan/photocopy
          of the death certificate. In cases where the bank account is frozen, a
          cheque payment will be sent to the beneficiary of the estate, provided
          their contact details are provided. Otherwise, refunds will be issued
          to the plan holder's estate. Please allow up to 28 days for the
          processing of refunds.
        </p>
        The plan can be transferred to another eligible individual as per our
        Terms and Conditions. It's important to note that the plan will only
        continue until the renewal date
        <p className="p_bot p_top">
          In the case of property sale, all plans must be canceled.
        </p>
        Feel free to contact us to discuss the option that best suits your
        needs.
      </>
    ),
  },
  {
    title:
      "I hold Power of Attorney/Court of Protection for a plan holder. How should I notify you of this?",
    desc: (
      <>
        In order for you to communicate with WeCare on behalf of the plan
        holder, we require a copy of the Power of Attorney, Court of Protection
        document, or an authorization letter from the customer. We will keep a
        copy of this documentation for future contact purposes and return the
        original to you.
        <p className="p_top p_bot">
          You can submit these documents to us through either of the following
          methods:
        </p>
        Email: <strong> info@Wecareboilerrepair.com</strong> <br />
        Mail: <strong> WeCare Boiler Repair Ltd,</strong>
        <p className="p_top">
          30 The Loont, <br />
          Winsford, <br />
          Cheshire, <br />
          CW7 1EU
        </p>
      </>
    ),
  },
];

export const planinclusations = [
  {
    title: "What’s not included in your plan",
    desc: (
      <>
        <p className="p_bot">
          We want you to understand exactly what our home cover plans do not
          include before you apply to join us
        </p>
        <div className="ul_about">
          <li className="p_bot">
            {" "}
            <strong>Boiler models:</strong> Potterton Powermax, Britony,
            Chaffoteaux, Sime, Servowarm and Elm Le Blanc; or any make or model
            of back boilers
          </li>
          <li className="p_bot">
            <strong>
              Repairing faults caused by limescale, sludge (dirty water
              contaminated by particles of dirt, rust other debris)
            </strong>
          </li>
          <li className="p_bot">
            <strong>
              Repairs where your boiler is deemed Beyond Economical Repair
              (BER),{" "}
            </strong>
            If your boiler is under seven years old and BER we may decide to
            replace your boiler. If its older and we may pay a contribution
            towards a new boiler
          </li>
          <li className="p_bot">
            <strong>
              Repairing pre-existing faults or faults that occur within the
              first 14 days of cover
            </strong>
          </li>
          <li className="p_bot">
            <strong>
              Systems or appliances that haven't been installed, maintained and
              used in accordance with manufacturer's instructions and or current
              regulations or best practice
            </strong>
          </li>
          <li className="p_bot">
            <strong>
              User tasks which are detailed in your user guide, re-pressurising
              your system and or bleeding your radiators
            </strong>
          </li>
          <li className="p_bot">
            <strgon>Trace and access </strgon> (work required to locate the
            fault) this is usually covered by your home insurance (no need to
            pay twice). Once the problem is found and accessible, we will
            happily come back and fix it
          </li>
          <li className="p_bot">
            Systems that are powered by anything other than natural gas
          </li>
          <li className="p_bot">Showers and shower pumps</li>
          <li className="p_bot">Upgrades or improvements to your system</li>
          <li className="p_bot">
            <strong>Accidental damage</strong>if you or someone working in your
            property causes a fault this should be covered by your home
            insurance
          </li>
          <li className="p_bot">
            <strong>Non-standard items or parts</strong>such as towel rails and
            underfloor heating. These need specialist parts and engineers, so
            we'd recommend getting in touch with the manufacturer for advice
          </li>
        </div>
      </>
    ),
  },
];
export const AboutData = [
  {
    title: "Why we set up WeCare",
    desc: (
      <>
        We founded WeCare with a vision to revolutionize customer support
        through top-tier home and boiler service plans. Drawing from our
        extensive background in plumbing and gas engineering, we excel in
        offering unparalleled care. Our unique blend of technical expertise and
        on-the-ground experience distinguishes us from the competition.
        <br />
        <br />
        Our commitment extends beyond boilers; we offer adaptable care plans
        encompassing central heating, plumbing, electrics, and more, catering to
        homeowners and landlords alike.
      </>
    ),
  },
  {
    title: "Who chooses WeCare for home and boiler care?",
    desc: (
      <>
        We cater to an extensive range of boiler systems found in homes, whether
        owned by residents or managed by landlords for tenants. Our clientele
        encompasses diverse demographics, from young couples and individuals to
        families and senior citizens.
      </>
    ),
  },
  {
    title: "Some of the reasons why our customers choose us:",
    desc: (
      <>
        <ul className="ul_about">
          <li>
            Fixed price plans for one or three years, offering unlimited repairs
          </li>
          <li>Breakdown assistance available for boilers of any age</li>
          <li>UK-based call center accessible round the clock, 24/7</li>
          <li>Swift response to emergency situations</li>
          <li>
            Our non-insurance status means no delays due to underwriters or
            extensive paperwork when scheduling repairs
          </li>
        </ul>
      </>
    ),
  },
  {
    title: "Why hundreds of customers a month switch to us",
    desc: "Included in our service is an annual boiler service valued at £80 (or a gas safety inspection for landlords). Additionally, you have the flexibility to choose your preferred start dates, ensuring uninterrupted care for your system and eliminating the need to juggle payments between multiple companies simultaneously.",
  },
  {
    title:
      "Why we offer fixed price home and boiler care plans for up to three years",
    desc: (
      <>
        Differing from our competitors, we provide fixed prices, ensuring
        transparency and enabling effective budget management. Our commitment
        extends to locking in your price for up to three years, no matter how
        many repairs you require.
        <br />
        <br />
        While many boiler insurance companies initially offer low prices and
        steeply raise renewal costs after the first year, we take a different
        approach. We prioritize long-term customer relationships over short-term
        gains, steering clear of sudden price hikes post-year one.
      </>
    ),
  },
];

let fromAboutUs;
export const ContentCard = [
  {
    title: (
      <>
        <AccountCircleOutlinedIcon /> My Account
      </>
    ),
    desc: (
      <>
        <Link to="/" state={(fromAboutUs = true)}>
          {/* <Link to={{ pathname: '/', state:  true  }}> */}
          <p>WeCare Plans</p>
        </Link>
        <br />
        <p> Update your details</p>
        <br />
        <p> Pay your bills</p>
        <br />
        <p> Download your document</p>
        <br />
        <p> Contact Support</p>
      </>
    ),
  },
  {
    title: (
      <>
        <HomeRepairServiceOutlinedIcon /> Request a Repair
      </>
    ),
    desc: (
      <>
        <p> We’ve made this bit really quick and easy.</p>
        <br />
        <p>
          Just a few quick questions and a brief description of your fault and
          we’ll appoint an engineer who will contact you to book an appointment
        </p>
      </>
    ),
  },
];
export const ContectFAQ = [
  {
    title: "Do I need landlord boiler cover?",
    desc: (
      <>
        With one in five boilers breaking down each year it's likely you'll need
        a boiler repair at some point, so it's a cost you'll need to take into
        consideration when you budget for the care of your investment.
        <p className="pt-1">
          {" "}
          If you're not switching from another provider, there's a 14-day
          exclusion period where your boiler won't be covered.
        </p>
      </>
    ),
  },
  {
    title: "When will my cover start?",
    desc: (
      <>
        With one in five boilers breaking down each year it's likely you'll need
        a boiler repair at some point, so it's a cost you'll need to take into
        consideration when you budget for the care of your investment.
        <p className="pt-1">
          Comprehensive landlord boiler cover from WeCare could also give you
          peace of mind that should something go wrong, we'll do all the legwork
          and get it sorted as soon as possible. With the option for your
          tenants to report the fault directly to us, too, you won't need to
          worry about a thing.
        </p>
      </>
    ),
  },
  {
    title: "Do you cover my boiler?",
    desc: (
      <>
        We service, and repair all makes and models of domestic boilers that are
        powered by natural gas, with the exception of Potterton Powermax,
        Britony, Chaffoteaux, Sime, Servowarm and Elm Le Blanc.
        <p className="p_top">
          We do not service or repair: LPG boilers, thermal store boilers, solid
          fuel boilers, oil boilers, electric boilers, back boilers or
          dual-purpose boilers.
        </p>
      </>
    ),
  },
];
